/**
 * Copyright 2025 Paion Data. All rights reserved.
 */
import "./ProjectCard.css";

interface ProjectCardProps {
  title: string;
  description: string;
  imgUrl: string;
}

export default function ProjectCard(props: ProjectCardProps): JSX.Element {
  return (
    <div className="proj-imgbx">
      <img src={props.imgUrl} />
      <div className="proj-txtx">
        <h4>{props.title}</h4>
        <span>{props.description}</span>
      </div>
    </div>
  );
}
